import { ComponentProps } from 'react';
import type { CurrencyISO } from '@/constants/currencies';

import MiniPriceChart, {
  DeferRender,
  MiniPriceChartDefinitions,
} from '@components/MiniPriceChart';
import useUser from '@/hooks/useUser';
import { useFlag } from '@/features/unleash';

import { NarrativeKeyMetricChart } from './NarrativeKeyMetricChart';

type NarrativeKeyMetricChartProps = ComponentProps<
  typeof NarrativeKeyMetricChart
> & { currencyISO: string };

export const FlaggedNarrativeKeyMetricChart = (
  props: NarrativeKeyMetricChartProps
) => {
  const { data: user } = useUser();
  const { flagsReady, enabled, variant } = useFlag({
    name: 'mono-primary-narrative-company-report',
  });

  if (user.loggedIn && flagsReady && enabled && variant.name === 'variant') {
    return <NarrativeKeyMetricChart {...props} />;
  }

  return (
    <div
      data-cy-id="key-metric-value-1Y-Price-Chart"
      className="col-span-2 lg:mr-x3"
    >
      <MiniPriceChartDefinitions />
      <DeferRender>
        <MiniPriceChart
          companyId={props.companyId}
          period="1Y"
          align="left"
          currencyISO={props.currencyISO as CurrencyISO}
        />
      </DeferRender>
    </div>
  );
};
